import { useEffect } from "react";

import { networkSlice, useNetworkState } from "../store/networkSlice";

/**
 * MED-1734: mirrors `navigator.onLine` (and the window online/offline events)
 * into `networkSlice.offline`, so the banner shows "hors ligne" at once and
 * the Axios request interceptor fails fast instead of waiting out the timeout.
 * Returns `true` while online.
 */
export const useOnlineStatus = (): boolean => {
  const { offline } = useNetworkState();

  useEffect(() => {
    const sync = () => networkSlice.setOffline(navigator.onLine === false);
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  return !offline;
};
